'use client';

import { useSession } from 'next-auth/react';
import { GlobalLoader } from '@/components/global-loader';

export function SessionLoadingGate({
  children,
}: { children: React.ReactNode }) {
  const { status } = useSession();
  if (status === 'loading') return <GlobalLoader />;
  return <>{children}</>;
}
